import React, { useState } from 'react';
import menu from '../../assets/navbar/menu.svg';
import img_close from '../../assets/sidebar/close.svg'
import './SimpleHeader.css';
import Sidenav from '../Sidenav/Sidenav';
import { NavLink } from "react-router-dom";



function SimpleHeader() {
    const [show, setShow] = useState(false);
    var body = document.getElementById('body');
    
    return (
        <header>
            <div className="sh_header">
                <div className="sh_container">
                    <img src={ menu } alt="menu" onClick={ () => {
                            body.style.overflow = 'hidden';
                            window[`scrollTo`]({top: 0, behavior: `smooth`}) 
                            setShow(!show)
                    } } className="sh_img_menu" /> 
                    <NavLink to="/" className="sh_link sh_img_close"><img src={img_close} alt="close" /> </NavLink>  
                </div>
            </div>
            <Sidenav show={ show } setShow={ setShow } />
        </header>
    )
}

export default SimpleHeader
